import { lazy } from 'solid-js';
import { createRouter } from '@solidjs/router';

export const Router = createRouter({
  routes: [
    { path: '/', component: lazy(() => import('./pages/Home')) },
    { path: '/contact', component: lazy(() => import('./pages/Contact')) },
    { path: '/confidentialite', component: lazy(() => import('./pages/Confidentialite')) },
    { path: '*404', component: lazy(() => import('./pages/NotFound')) },
  ],
});
export const { paths } = Router;
